import { useMutation } from "@apollo/client";

import {
  CreateOneTimeDepositMutation,
  CreateOneTimeDepositMutationVariables,
  TransactionTime,
} from "@ctypes";
import { CREATE_ONE_TIME_DEPOSIT, TRANSACTIONS } from "@graphql";
import { DEFAULT_SIZE } from "@hooks/transfers";

export const useCreateOneTimeDeposit = () => {
  return useMutation<CreateOneTimeDepositMutation, CreateOneTimeDepositMutationVariables>(
    CREATE_ONE_TIME_DEPOSIT,
    {
      refetchQueries: [
        {
          query: TRANSACTIONS,
          variables: {
            size: DEFAULT_SIZE,
            time: TransactionTime.Upcoming,
          },
        },
        {
          query: TRANSACTIONS,
          variables: {
            size: DEFAULT_SIZE,
            time: TransactionTime.Past,
          },
        },
        {
          query: TRANSACTIONS,
          variables: {
            size: DEFAULT_SIZE,
            time: TransactionTime.Pending,
          },
        },
      ],
    },
  );
};
